import { getCommonDataFromPageContext, maxNumberOfProducts, listName, getCatalogApiUrl, getProductCategoryCode } from './certona-recommendation-v2-utils.es6';
import { getPageType } from '../utils/gtm-utilities.es6';

export function getLanguageCodeForCapi(languageFromUrl) {
    if (languageFromUrl.includes('_')) {
        const languageParts = languageFromUrl.split('_');
        return `${languageParts[0].toLowerCase()}_${languageParts[1].toUpperCase()}`;
    }
    return languageFromUrl;
}

function getName(el, lang) {
    let itemName = el.names[lang];
    if ((typeof itemName === 'undefined' || itemName === '') && lang.includes('_')) {
        itemName = el.names[lang.split('_')[0]]; // trying to take the base language name
    }
    return itemName;
}

export function formatRandomRecs(rawData, languageFromUrl, countryLanguage, pagePath) {
    try {
        const languageUrlForCapi = getLanguageCodeForCapi(languageFromUrl);
        return rawData.slice(0, maxNumberOfProducts).map((el, idx) => {
            // host is hardcoded since startRecommendations() works only with www.gucci.com :)
            const productUrl = `https://www.gucci.com${countryLanguage}${el.url}`;
            const currencyCode = window.currencyData.isocode;
            const currencyPrecision = window.currencyData.digits;
            const capiPrice = el.prices[currencyCode.toLowerCase()];
            const formattedPrice = (Math.round(capiPrice) / 10 ** currencyPrecision).toString();
            const itemName = getName(el, languageUrlForCapi);
            return {
                id: el.styleCode,
                position: (idx + 1).toString(),
                list: listName,

                ...getCommonDataFromPageContext(productUrl, pagePath, getPageType(pagePath)),

                details: {
                    name: itemName,
                    url: productUrl,
                    unit_price: formattedPrice,
                    image_url: el.image1.replace('$format$', 'DarkGray_Center_0_0_2400x2400')
                }
            };
        });
    } catch (e) {
        console.error(e);
        return Promise.reject(new Error('Failed parsing random recommendations. Received value: ', rawData));
    }
}

export async function fetchRandomRecommendations(countryUrl, languageUrl, countryLanguage, pagePath) {
    const capiCountry = countryUrl === 'uk' ? 'gb' : countryUrl;
    let url = `https://${getCatalogApiUrl()}/v1/products/random/${capiCountry}?max=${maxNumberOfProducts}`;
    const productCategoryCode = getProductCategoryCode();
    if (typeof productCategoryCode !== 'undefined' && productCategoryCode !== '') {
        url += `&category=${productCategoryCode}`;
    }
    const res = await fetch(url);
    const resBody = await res.json();
    if (res.ok) {
        return formatRandomRecs(resBody, languageUrl, countryLanguage, pagePath);
    }

    console.error(`Random reco: couldn't fetch for ${res.statusText}, ${resBody.message}`);
    return Promise.reject(new Error('fetched failed'));
}
